import { z } from 'zod';
/**
 * `Visit.result` — ce que le passage a donné ([M3](../../../../docs/MODELE-DONNEES.md#m3)) : un
 * **fait constaté sur place**, écrit une fois, jamais un `status`.
 *
 * ⚠️ **C'est ici que vit l'absence, et pas sur le rendez-vous.** `absent` a été retiré
 * d'`Appointment.result` le 31/08/2026 pour cette raison exacte : un rendez-vous ne sait que ce
 * qui a été **convenu**, une visite dit ce qui a été **constaté**. Une absence est donc une visite
 * qui a bien eu lieu et n'a rien pu contrôler.
 *
 * Trois des quatre valeurs décrivent une visite **infructueuse** — `absent`, `refused`,
 * `inaccessible` —, et c'est la distinction que cette table existe pour porter : seule
 * `inspected` produit une `Inspection`. Sans elle, un déplacement sans contrôle ne laisserait
 * aucune trace, et la demande resterait indéfiniment « à planifier » sans que rien ne dise
 * pourquoi.
 */
export const VISIT_RESULTS = ['absent', 'refused', 'inspected', 'inaccessible'];
export const visitResultSchema = z.enum(VISIT_RESULTS);
//# sourceMappingURL=visit.js.map